// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-grid {
  align-items: start;
}

.scope-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
}

.scope-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 2.8rem;
  padding: 0.7rem 1rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(29, 78, 216, 0.12);
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98), rgba(241, 245, 255, 0.94));
  color: #33516a;
  cursor: pointer;
  font: inherit;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    border-color 0.16s ease,
    background 0.16s ease,
    color 0.16s ease;
}

.scope-pill:hover,
.scope-pill:focus-visible {
  transform: translateY(-1px);
  border-color: rgba(37, 99, 235, 0.3);
  box-shadow: 0 14px 26px rgba(37, 99, 235, 0.12);
}

.scope-pill span {
  font-size: 0.82rem;
  font-weight: 600;
}

.scope-pill strong {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  padding: 0.1rem 0.55rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  color: #163851;
  font-size: 0.86rem;
}

.scope-pill.active {
  border-color: rgba(30, 64, 175, 0.38);
  background: linear-gradient(135deg, rgba(30, 64, 175, 0.12), rgba(14, 116, 144, 0.12));
  color: #163851;
  box-shadow: 0 18px 32px rgba(30, 64, 175, 0.16);
}

.filter-summary-row {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.filter-summary-row .helper-text {
  margin: 0;
}

.side-panel {
  position: sticky;
  top: 0.5rem;
}

.chip.factura-generada {
  background: rgba(14, 165, 233, 0.16);
  color: #0369a1;
}

.chip.rechazada {
  background: rgba(239, 68, 68, 0.16);
  color: #b91c1c;
}

.chip.cliente-notificado {
  background: rgba(217, 70, 239, 0.12);
  color: #a21caf;
}

.status-cell,
.table-row-meta {
  display: grid;
  gap: 0.35rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.status-select-shell {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 2.2rem;
  max-width: 100%;
  border-radius: 999px;
  border: 1px solid transparent;
  padding: 0 0.85rem;
  background: rgba(15, 23, 42, 0.08);
  color: #264258;
}

.status-select-shell.pendiente {
  background: rgba(234, 179, 8, 0.16);
  color: #92400e;
}

.status-select-shell.aprobada {
  background: rgba(34, 197, 94, 0.14);
  color: #166534;
}

.status-select-shell.enviada {
  background: rgba(8, 145, 178, 0.14);
  color: #0f766e;
}

.status-select-shell.factura-generada {
  background: rgba(14, 165, 233, 0.16);
  color: #0369a1;
}

.status-select-shell.rechazada {
  background: rgba(239, 68, 68, 0.16);
  color: #b91c1c;
}

.status-select-shell.cliente-notificado {
  background: rgba(217, 70, 239, 0.12);
  color: #a21caf;
}

.status-select-input {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 700;
  padding: 0.1rem 1.2rem 0.1rem 0;
  appearance: none;
  cursor: pointer;
}

.status-select-input:disabled {
  cursor: wait;
  opacity: 0.72;
}

.status-select-shell:focus-within {
  outline: 2px solid rgba(15, 91, 122, 0.28);
  outline-offset: 2px;
}

.status-select-shell::after {
  content: '▾';
  position: absolute;
  right: 0.75rem;
  pointer-events: none;
  font-size: 0.8rem;
  opacity: 0.75;
}

.status-inline-message {
  font-size: 0.75rem;
  color: #35516a;
}

.status-inline-message.success {
  color: #027a48;
}

.status-inline-message.error {
  color: #b42318;
}

.table-row-inline-link {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 700;
  color: #0f5b7a;
  text-decoration: none;
}

.table-row-inline-link:hover,
.table-row-inline-link:focus-visible {
  text-decoration: underline;
}

.approved-card-main {
  display: grid;
  gap: 0.85rem;
  flex: 1 1 480px;
}

.approved-card-topline {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: flex-start;
  flex-wrap: wrap;
}

.approved-card-topline p {
  margin: 0;
}

.approved-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.65rem 1rem;
}

.approved-card-details span {
  display: grid;
  gap: 0.2rem;
  color: #35516a;
  font-size: 0.9rem;
}

.approved-card-details strong {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7f92;
}

.approved-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.approved-info-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  background: rgba(15, 23, 42, 0.05);
  color: #264258;
  font-size: 0.8rem;
  font-weight: 600;
}

.approved-info-chip.subtle {
  background: rgba(59, 130, 246, 0.08);
}

.approved-info-chip.success {
  background: rgba(34, 197, 94, 0.14);
  color: #166534;
}

.approved-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  justify-content: flex-end;
}

.approved-user-sent-panel {
  display: grid;
  gap: 0.45rem;
  justify-items: end;
  margin-top: 0.75rem;
}

.approved-user-sent-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.9rem;
  border: 1px solid rgba(15, 91, 122, 0.16);
  background: rgba(255, 255, 255, 0.84);
  color: #183b56;
  font-size: 0.84rem;
  font-weight: 600;
}

.approved-user-sent-toggle input {
  margin: 0;
  accent-color: #0f766e;
}

.approved-user-sent-toggle.active {
  border-color: rgba(22, 101, 52, 0.2);
  background: rgba(34, 197, 94, 0.1);
  color: #166534;
}

:root[data-theme='dark'] .scope-pill {
  border-color: rgba(86, 132, 168, 0.34);
  background: linear-gradient(150deg, rgba(16, 34, 48, 0.96), rgba(12, 26, 38, 0.94));
  color: #d6e5ef;
  box-shadow: 0 12px 24px rgba(2, 8, 14, 0.34);
}

:root[data-theme='dark'] .scope-pill strong {
  background: rgba(118, 168, 205, 0.12);
  color: #eff8ff;
}

:root[data-theme='dark'] .scope-pill.active {
  border-color: rgba(125, 189, 231, 0.44);
  background: linear-gradient(135deg, rgba(33, 91, 118, 0.42), rgba(22, 61, 93, 0.5));
}

:root[data-theme='dark'] .approved-card-details span {
  color: #d3e3ee;
}

:root[data-theme='dark'] .status-select-shell {
  background: rgba(118, 168, 205, 0.12);
  color: #e6f4ff;
}

:root[data-theme='dark'] .status-select-shell.pendiente {
  background: rgba(245, 158, 11, 0.18);
  color: #fde68a;
}

:root[data-theme='dark'] .status-select-shell.aprobada {
  background: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
}

:root[data-theme='dark'] .status-select-shell.enviada {
  background: rgba(34, 211, 238, 0.18);
  color: #a5f3fc;
}

:root[data-theme='dark'] .status-select-shell.factura-generada {
  background: rgba(56, 189, 248, 0.2);
  color: #bae6fd;
}

:root[data-theme='dark'] .status-select-shell.rechazada {
  background: rgba(248, 113, 113, 0.2);
  color: #fecaca;
}

:root[data-theme='dark'] .status-select-shell.cliente-notificado {
  background: rgba(232, 121, 249, 0.2);
  color: #f5d0fe;
}

:root[data-theme='dark'] .status-inline-message {
  color: #c5d9e6;
}

:root[data-theme='dark'] .status-inline-message.success {
  color: #6ee7b7;
}

:root[data-theme='dark'] .status-inline-message.error {
  color: #fda4af;
}

:root[data-theme='dark'] .table-row-inline-link {
  color: #7dd3fc;
}

:root[data-theme='dark'] .approved-card-details strong {
  color: #8ea8ba;
}

:root[data-theme='dark'] .approved-info-chip {
  background: rgba(118, 168, 205, 0.12);
  color: #e6f4ff;
}

:root[data-theme='dark'] .approved-info-chip.subtle {
  background: rgba(56, 189, 248, 0.14);
}

:root[data-theme='dark'] .approved-info-chip.success {
  background: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
}

:root[data-theme='dark'] .approved-user-sent-toggle {
  border-color: rgba(86, 132, 168, 0.34);
  background: linear-gradient(150deg, rgba(16, 34, 48, 0.92), rgba(12, 26, 38, 0.9));
  color: #d6e5ef;
}

:root[data-theme='dark'] .approved-user-sent-toggle.active {
  border-color: rgba(34, 197, 94, 0.28);
  background: rgba(34, 197, 94, 0.16);
  color: #bbf7d0;
}

@media (max-width: 1200px) {
  .content-grid {
    grid-template-columns: 1fr;
  }

  .side-panel {
    position: static;
  }
}

@media (max-width: 768px) {
  .scope-pill {
    width: 100%;
    justify-content: space-between;
  }

  .approved-card-topline,
  .approved-meta,
  .approved-actions,
  .filter-summary-row {
    align-items: stretch;
  }

  .approved-actions .btn,
  .filter-summary-row .btn {
    width: 100%;
  }

  .approved-user-sent-panel {
    justify-items: stretch;
  }

  .approved-user-sent-toggle {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-facturacion.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,yCAAyC;EACzC,yFAAyF;EACzF,cAAc;EACd,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C;;;;;oBAKkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sFAAsF;EACtF,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mFAAmF;EACnF,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mFAAmF;AACrF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kFAAkF;EAClF,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;;;;IAIE,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".content-grid {\n  align-items: start;\n}\n\n.scope-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.scope-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-height: 2.8rem;\n  padding: 0.7rem 1rem;\n  border-radius: 0.95rem;\n  border: 1px solid rgba(29, 78, 216, 0.12);\n  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98), rgba(241, 245, 255, 0.94));\n  color: #33516a;\n  cursor: pointer;\n  font: inherit;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);\n  transition:\n    transform 0.16s ease,\n    box-shadow 0.16s ease,\n    border-color 0.16s ease,\n    background 0.16s ease,\n    color 0.16s ease;\n}\n\n.scope-pill:hover,\n.scope-pill:focus-visible {\n  transform: translateY(-1px);\n  border-color: rgba(37, 99, 235, 0.3);\n  box-shadow: 0 14px 26px rgba(37, 99, 235, 0.12);\n}\n\n.scope-pill span {\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.scope-pill strong {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2rem;\n  padding: 0.1rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.8);\n  color: #163851;\n  font-size: 0.86rem;\n}\n\n.scope-pill.active {\n  border-color: rgba(30, 64, 175, 0.38);\n  background: linear-gradient(135deg, rgba(30, 64, 175, 0.12), rgba(14, 116, 144, 0.12));\n  color: #163851;\n  box-shadow: 0 18px 32px rgba(30, 64, 175, 0.16);\n}\n\n.filter-summary-row {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.filter-summary-row .helper-text {\n  margin: 0;\n}\n\n.side-panel {\n  position: sticky;\n  top: 0.5rem;\n}\n\n.chip.factura-generada {\n  background: rgba(14, 165, 233, 0.16);\n  color: #0369a1;\n}\n\n.chip.rechazada {\n  background: rgba(239, 68, 68, 0.16);\n  color: #b91c1c;\n}\n\n.chip.cliente-notificado {\n  background: rgba(217, 70, 239, 0.12);\n  color: #a21caf;\n}\n\n.status-cell,\n.table-row-meta {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.status-select-shell {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-height: 2.2rem;\n  max-width: 100%;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  padding: 0 0.85rem;\n  background: rgba(15, 23, 42, 0.08);\n  color: #264258;\n}\n\n.status-select-shell.pendiente {\n  background: rgba(234, 179, 8, 0.16);\n  color: #92400e;\n}\n\n.status-select-shell.aprobada {\n  background: rgba(34, 197, 94, 0.14);\n  color: #166534;\n}\n\n.status-select-shell.enviada {\n  background: rgba(8, 145, 178, 0.14);\n  color: #0f766e;\n}\n\n.status-select-shell.factura-generada {\n  background: rgba(14, 165, 233, 0.16);\n  color: #0369a1;\n}\n\n.status-select-shell.rechazada {\n  background: rgba(239, 68, 68, 0.16);\n  color: #b91c1c;\n}\n\n.status-select-shell.cliente-notificado {\n  background: rgba(217, 70, 239, 0.12);\n  color: #a21caf;\n}\n\n.status-select-input {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 700;\n  padding: 0.1rem 1.2rem 0.1rem 0;\n  appearance: none;\n  cursor: pointer;\n}\n\n.status-select-input:disabled {\n  cursor: wait;\n  opacity: 0.72;\n}\n\n.status-select-shell:focus-within {\n  outline: 2px solid rgba(15, 91, 122, 0.28);\n  outline-offset: 2px;\n}\n\n.status-select-shell::after {\n  content: '▾';\n  position: absolute;\n  right: 0.75rem;\n  pointer-events: none;\n  font-size: 0.8rem;\n  opacity: 0.75;\n}\n\n.status-inline-message {\n  font-size: 0.75rem;\n  color: #35516a;\n}\n\n.status-inline-message.success {\n  color: #027a48;\n}\n\n.status-inline-message.error {\n  color: #b42318;\n}\n\n.table-row-inline-link {\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #0f5b7a;\n  text-decoration: none;\n}\n\n.table-row-inline-link:hover,\n.table-row-inline-link:focus-visible {\n  text-decoration: underline;\n}\n\n.approved-card-main {\n  display: grid;\n  gap: 0.85rem;\n  flex: 1 1 480px;\n}\n\n.approved-card-topline {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.approved-card-topline p {\n  margin: 0;\n}\n\n.approved-card-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n.approved-card-details span {\n  display: grid;\n  gap: 0.2rem;\n  color: #35516a;\n  font-size: 0.9rem;\n}\n\n.approved-card-details strong {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #6b7f92;\n}\n\n.approved-chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n}\n\n.approved-info-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 0.35rem 0.8rem;\n  background: rgba(15, 23, 42, 0.05);\n  color: #264258;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.approved-info-chip.subtle {\n  background: rgba(59, 130, 246, 0.08);\n}\n\n.approved-info-chip.success {\n  background: rgba(34, 197, 94, 0.14);\n  color: #166534;\n}\n\n.approved-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  justify-content: flex-end;\n}\n\n.approved-user-sent-panel {\n  display: grid;\n  gap: 0.45rem;\n  justify-items: end;\n  margin-top: 0.75rem;\n}\n\n.approved-user-sent-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: 0.9rem;\n  border: 1px solid rgba(15, 91, 122, 0.16);\n  background: rgba(255, 255, 255, 0.84);\n  color: #183b56;\n  font-size: 0.84rem;\n  font-weight: 600;\n}\n\n.approved-user-sent-toggle input {\n  margin: 0;\n  accent-color: #0f766e;\n}\n\n.approved-user-sent-toggle.active {\n  border-color: rgba(22, 101, 52, 0.2);\n  background: rgba(34, 197, 94, 0.1);\n  color: #166534;\n}\n\n:root[data-theme='dark'] .scope-pill {\n  border-color: rgba(86, 132, 168, 0.34);\n  background: linear-gradient(150deg, rgba(16, 34, 48, 0.96), rgba(12, 26, 38, 0.94));\n  color: #d6e5ef;\n  box-shadow: 0 12px 24px rgba(2, 8, 14, 0.34);\n}\n\n:root[data-theme='dark'] .scope-pill strong {\n  background: rgba(118, 168, 205, 0.12);\n  color: #eff8ff;\n}\n\n:root[data-theme='dark'] .scope-pill.active {\n  border-color: rgba(125, 189, 231, 0.44);\n  background: linear-gradient(135deg, rgba(33, 91, 118, 0.42), rgba(22, 61, 93, 0.5));\n}\n\n:root[data-theme='dark'] .approved-card-details span {\n  color: #d3e3ee;\n}\n\n:root[data-theme='dark'] .status-select-shell {\n  background: rgba(118, 168, 205, 0.12);\n  color: #e6f4ff;\n}\n\n:root[data-theme='dark'] .status-select-shell.pendiente {\n  background: rgba(245, 158, 11, 0.18);\n  color: #fde68a;\n}\n\n:root[data-theme='dark'] .status-select-shell.aprobada {\n  background: rgba(34, 197, 94, 0.18);\n  color: #bbf7d0;\n}\n\n:root[data-theme='dark'] .status-select-shell.enviada {\n  background: rgba(34, 211, 238, 0.18);\n  color: #a5f3fc;\n}\n\n:root[data-theme='dark'] .status-select-shell.factura-generada {\n  background: rgba(56, 189, 248, 0.2);\n  color: #bae6fd;\n}\n\n:root[data-theme='dark'] .status-select-shell.rechazada {\n  background: rgba(248, 113, 113, 0.2);\n  color: #fecaca;\n}\n\n:root[data-theme='dark'] .status-select-shell.cliente-notificado {\n  background: rgba(232, 121, 249, 0.2);\n  color: #f5d0fe;\n}\n\n:root[data-theme='dark'] .status-inline-message {\n  color: #c5d9e6;\n}\n\n:root[data-theme='dark'] .status-inline-message.success {\n  color: #6ee7b7;\n}\n\n:root[data-theme='dark'] .status-inline-message.error {\n  color: #fda4af;\n}\n\n:root[data-theme='dark'] .table-row-inline-link {\n  color: #7dd3fc;\n}\n\n:root[data-theme='dark'] .approved-card-details strong {\n  color: #8ea8ba;\n}\n\n:root[data-theme='dark'] .approved-info-chip {\n  background: rgba(118, 168, 205, 0.12);\n  color: #e6f4ff;\n}\n\n:root[data-theme='dark'] .approved-info-chip.subtle {\n  background: rgba(56, 189, 248, 0.14);\n}\n\n:root[data-theme='dark'] .approved-info-chip.success {\n  background: rgba(34, 197, 94, 0.18);\n  color: #bbf7d0;\n}\n\n:root[data-theme='dark'] .approved-user-sent-toggle {\n  border-color: rgba(86, 132, 168, 0.34);\n  background: linear-gradient(150deg, rgba(16, 34, 48, 0.92), rgba(12, 26, 38, 0.9));\n  color: #d6e5ef;\n}\n\n:root[data-theme='dark'] .approved-user-sent-toggle.active {\n  border-color: rgba(34, 197, 94, 0.28);\n  background: rgba(34, 197, 94, 0.16);\n  color: #bbf7d0;\n}\n\n@media (max-width: 1200px) {\n  .content-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .side-panel {\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .scope-pill {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .approved-card-topline,\n  .approved-meta,\n  .approved-actions,\n  .filter-summary-row {\n    align-items: stretch;\n  }\n\n  .approved-actions .btn,\n  .filter-summary-row .btn {\n    width: 100%;\n  }\n\n  .approved-user-sent-panel {\n    justify-items: stretch;\n  }\n\n  .approved-user-sent-toggle {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
